<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <div class="d-flex btn-container">
      <v-btn class="ml-auto" text @click="updateSendCorrectionsDialog(false)">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </div>
    <v-card-title class="mb-5">Επιστροφή για διόρθωση </v-card-title>

    <v-form class="form d-flex flex-column justify-center">
      <v-textarea v-model="comment" label="Σχόλια" no-resize> </v-textarea>
      <div class="d-flex justify-center">
        <v-btn
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onSubmit"
        >
          <span>Επιστροφή για διόρθωση</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="updateSendCorrectionsDialog(false)"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  props: ["filters"],
  data() {
    return {
      loader: false,
      comment: "",
    };
  },
  computed: {
    ...mapState({
      currentHcmcReport: (state) => state.hcmcreports.currentHcmcReport,
    }),
  },
  methods: {
    ...mapMutations(["updateSendCorrectionsDialog"]),
    ...mapActions(["returnForCorrections"]),

    async onSubmit() {
      try {
        this.loader = true;
        await this.returnForCorrections({
          content: {
            reportVersionId: this.currentHcmcReport.submittedVersionId,
            hcmcValidationMessage: this.comment,
          },
          filters: this.filters,
        });
        this.loader = false;
        this.updateSendCorrectionsDialog(false);
        this.$router.push(`/hcmc/pending/reports`);
      } catch (e) {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btn-container {
  width: 100%;
}
</style>